export default __webpack_public_path__ + "static/whitecard-7798000227f58cac387ff11e6956c08e.png";